import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDataCronogramaSGQ } from "../../../../../../common/components/default_data_prevista_CronogramaSGQ";

// Header 

type Props = {
  tipoPesquisa: number,
  pesquisa: string | Date | number | null,
  status: number;
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void,
  handlePesquisa: (v: string | Date | number | null) => void,
  handleStatus: (s: number) => void,
};

export const Header = ({ tipoPesquisa, pesquisa, status, handlePesquisa, handleStatus, handleTipoPesquisa, onClearFilters }: Props) => {
  
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
          <div className="flex gap-1">
            <FormControl size="small" sx={{ width: "275px" }}>
              <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
              <Select
                size="small"
                labelId="modulo-dashboard"
                label="Pesquisar por"
                value={tipoPesquisa}
                onChange={(event: SelectChangeEvent<number>) => {
                  handlePesquisa(null);
                  handleTipoPesquisa(event.target.value as number)
                }}>
                <MenuItem value={0}>Ano Previsto</MenuItem>
                <MenuItem value={1}>Ano Realizado</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="w-full">
            {(tipoPesquisa === 0 || tipoPesquisa === 1) && (
              <DefaultDataCronogramaSGQ
                key={tipoPesquisa} 
                name="Pesquisar"
                value={typeof pesquisa === 'number' ? pesquisa : null}
                onChange={(valor) => handlePesquisa(valor ?? null)}
                Tipo={tipoPesquisa === 0 ? "DataPrevista" : "DataRealizada"} 
              />
            )}
          </div>

          <FormControl size="small" sx={{ width: "220px" }}>
            <InputLabel id="status-label" size="small">Status</InputLabel>
            <Select
              size="small"
              labelId="status-label"
              label="Status"
              value={status}
              onChange={(event: SelectChangeEvent<number>) => {
                handleStatus(event.target.value as number)
              }}>
              <MenuItem value={0}>Todas ações</MenuItem>
              <MenuItem value={1}>Dentro do prazo</MenuItem>
              <MenuItem value={2}>Atrasados</MenuItem>
              <MenuItem value={3}>Realizados</MenuItem>
            </Select>
          </FormControl>

          {/* Botão Limpar */}
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}